import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared/shared.module';
import { WebsitesModule } from '../../websites/websites.module';
import { SharedComponentsModule } from '../../shared/shared-components.module';
import { BusinessDirectoriesComponent } from './BusinessDirectories/BusinessDirectories.component';
import { ChooseLocalProfileCategoryComponent } from './ChooseLocalProfileCategory/ChooseLocalProfileCategory.component';
import { ClassifiedBusinessListingsComponent } from './ClassifiedBusinessListings/ClassifiedBusinessListings.component';
import { CommentComponent } from './Comment/Comment.component';
import { CommentsComponent } from './Comments/Comments.component';
import { CustomManualComponent } from './CustomManual/CustomManual.component';
import { OnsiteRecommendationComponent } from './components/OnsiteRecommendation/OnsiteRecommendation.component';
import { CustomerInformationLegacyComponent } from './CustomerInformationLegacy/CustomerInformationLegacy.component';
import { CustomerInformationComponent } from './customer-information/customer-information.component';
import { SeoContentSurveyLegacyComponent } from './SeoContentSurveyLegacy/SeoContentSurveyLegacy.component';
import { SeoContentSurveyComponent } from './seo-content-survey/seo-content-survey.component';
import { CustomerTargetUrlsComponent } from './customer-target-urls/customer-target-urls.component';
import { CustomImplementationActionComponent } from './CustomImplementationAction/CustomImplementationAction.component';
import { FilesLegacyComponent } from './FilesLegacy/FilesLegacy.component';
import { FilesComponent } from './files/files.component';
import { InformationLegacyComponent } from './InformationLegacy/InformationLegacy.component';
import { InformationComponent } from './information/information.component';
import { LocalBusinessCitationsComponent } from './LocalBusinessCitations/LocalBusinessCitations.component';
import { OnsiteBloggingReviewComponent } from './OnsiteBloggingReview/OnsiteBloggingReview.component';
import { OnsiteBloggingRevisionComponent } from './OnsiteBloggingRevision/OnsiteBloggingRevision.component';
import { OnsiteCopyCreateContentComponent } from './OnsiteCopyCreateContent/OnsiteCopyCreateContent.component';
import { OnsiteCopyReviewComponent } from './OnsiteCopyReview/OnsiteCopyReview.component';
import { OnsiteBloggingImplementationComponent } from './OnsiteImplementation/OnsiteBloggingImplementation/OnsiteBloggingImplementation.component';
import { OnsiteCopyImplementationComponent } from './OnsiteImplementation/OnsiteCopyImplementation/OnsiteCopyImplementation.component';
import { OnsiteImplementationComponent } from './OnsiteImplementation/OnsiteImplementation/OnsiteImplementation.component';
import { OnsiteRecommendationImplementationComponent } from './OnsiteImplementation/OnsiteRecommendationImplementation/OnsiteRecommendationImplementation.component';
import { OnsiteBloggingImplementationReviewComponent } from './OnsiteImplementationReview/OnsiteBloggingImplementationReview/OnsiteBloggingImplementationReview.component';
import { OnsiteCopyImplementationReviewComponent } from './OnsiteImplementationReview/OnsiteCopyImplementationReview/OnsiteCopyImplementationReview.component';
import { OnsiteImplementationReviewComponent } from './OnsiteImplementationReview/OnsiteImplementationReview/OnsiteImplementationReview.component';
import { OnsiteRecommendationImplementationReviewComponent } from './OnsiteImplementationReview/OnsiteRecommendationImplementationReview/OnsiteRecommendationImplementationReview.component';
import { GoogleAnalyticsAccessComponent } from './GoogleAnalyticsAccess/GoogleAnalyticsAccess.component';
import { OnsiteRecommendationComponent as OnsiteRecommendationComponent2 } from './OnsiteRecommendation/OnsiteRecommendation.component';
import { OnsiteRecommendationReviewComponent } from './OnsiteRecommendationReview/OnsiteRecommendationReview.component';
import { BusinessProfileValidationAndAugmentationComponent } from './BusinessProfileValidationAndAugmentation/BusinessProfileValidationAndAugmentation.component';
import { StandaloneBusinessProfileValidationAndAugmentationComponent } from './StandaloneBusinessProfileValidationAndAugmentation/StandaloneBusinessProfileValidationAndAugmentation.component';
import { PreAuditComponent } from './PreAudit/PreAudit.component';
import { ProactiveUnderPerformingKeywordComponent } from './ProactiveUnderPerformingKeyword/ProactiveUnderPerformingKeyword.component';
import { ResolveBusinessProfileIssuesComponent } from './ResolveBusinessProfileIssues/ResolveBusinessProfileIssues.component';
import { WebsiteBookmarkingComponent } from './WebsiteBookmarking/WebsiteBookmarking.component';
import { ChangedKeywordsComponent } from './changed-keywords/changed-keywords.component';
import { PremiumMonthlyCampaignUpdateComponent } from './premium-monthly-campaign-update/premium-monthly-campaign-update.component';
import { RejectionComponent } from './rejections/rejection.component';
import { OnsiteBloggingCreateContentComponent } from './onsite-blogging-create-content/onsite-blogging-create-content.component';
import { ManageCustomerModule } from '../../managecustomer/manage-customer.module';
import { GoogleIntegrationSetupComponent } from './google-integration-setup/google-integration-setup.component';
import { BoostSiteAccountReadOnlyComponent } from './boost-site-account-read-only/boost-site-account-read-only.component';
import { BoostSiteAccountsReadOnlyComponent } from './boost-site-accounts-read-only/boost-site-accounts-read-only.component';
import { CustomerAccountGroupReadOnlyComponent } from './customer-account-group-read-only/customer-account-group-read-only.component';
import { CustomerAccountReadOnlyComponent } from './customer-account-read-only/customer-account-read-only.component';
import { ExternalAccessReadOnlyComponent } from './external-access-read-only/external-access-read-only.component';
import { PageOptimizationCreateContentComponent } from './page-optimization/create-content/create-content.component';
import { PageOptimizationReviewContentComponent } from './page-optimization/review-content/review-content.component';
import { PageOptimizationRewriteContentComponent } from './page-optimization/rewrite-content/rewrite-content.component';
import { PageOptimizationImplementContentComponent } from './page-optimization/implement-content/implement-content.component';
import { PageOptimizationReviewImplementationComponent } from './page-optimization/review-implementation/review-implementation.component';
import { PageOptimizationAuditComponent } from './page-optimization/shared/audit/audit.component';
import { PageOptimizationContentComponent } from './page-optimization/shared/content/content.component';
import { PageOptimizationFloatingPanelsComponent } from './page-optimization/shared/floating-panels/floating-panels.component';
import { PageOptimizationImplementationUrlComponent } from './page-optimization/shared/implementation-url/implementation-url.component';
import { PageOptimizationInstructionsComponent } from './page-optimization/shared/instructions/instructions.component';
import { PageOptimizationNoteComponent } from './page-optimization/shared/note/note.component';
import { PageOptimizationNotesComponent } from './page-optimization/shared/notes/notes.component';
import { PageOptimizationChecklistComponent } from './page-optimization/shared/checklist/checklist.component';

@NgModule({
  declarations: [
    BusinessDirectoriesComponent,
    ChooseLocalProfileCategoryComponent,
    ClassifiedBusinessListingsComponent,
    CommentComponent,
    CommentsComponent,
    CustomManualComponent,
    OnsiteRecommendationComponent,
    CustomerInformationLegacyComponent,
    CustomerInformationComponent,
    SeoContentSurveyLegacyComponent,
    SeoContentSurveyComponent,
    CustomerTargetUrlsComponent,
    CustomImplementationActionComponent,
    FilesLegacyComponent,
    FilesComponent,
    InformationLegacyComponent,
    InformationComponent,
    LocalBusinessCitationsComponent,
    OnsiteBloggingReviewComponent,
    OnsiteBloggingRevisionComponent,
    OnsiteCopyCreateContentComponent,
    OnsiteCopyReviewComponent,
    OnsiteBloggingImplementationComponent,
    OnsiteCopyImplementationComponent,
    OnsiteImplementationComponent,
    OnsiteRecommendationImplementationComponent,
    OnsiteBloggingImplementationReviewComponent,
    OnsiteCopyImplementationReviewComponent,
    OnsiteImplementationReviewComponent,
    OnsiteRecommendationImplementationReviewComponent,
    GoogleAnalyticsAccessComponent,
    OnsiteRecommendationComponent2,
    OnsiteRecommendationReviewComponent,
    BusinessProfileValidationAndAugmentationComponent,
    StandaloneBusinessProfileValidationAndAugmentationComponent,
    PreAuditComponent,
    ProactiveUnderPerformingKeywordComponent,
    ResolveBusinessProfileIssuesComponent,
    WebsiteBookmarkingComponent,
    ChangedKeywordsComponent,
    PremiumMonthlyCampaignUpdateComponent,
    RejectionComponent,
    OnsiteBloggingCreateContentComponent,
    GoogleIntegrationSetupComponent,
    BoostSiteAccountReadOnlyComponent,
    BoostSiteAccountsReadOnlyComponent,
    CustomerAccountGroupReadOnlyComponent,
    CustomerAccountReadOnlyComponent,
    ExternalAccessReadOnlyComponent,
    PageOptimizationCreateContentComponent,
    PageOptimizationReviewContentComponent,
    PageOptimizationRewriteContentComponent,
    PageOptimizationImplementContentComponent,
    PageOptimizationReviewImplementationComponent,
    PageOptimizationAuditComponent,
    PageOptimizationContentComponent,
    PageOptimizationFloatingPanelsComponent,
    PageOptimizationImplementationUrlComponent,
    PageOptimizationInstructionsComponent,
    PageOptimizationNoteComponent,
    PageOptimizationNotesComponent,
    PageOptimizationChecklistComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    WebsitesModule,
    SharedComponentsModule,
    ManageCustomerModule
  ],
  exports: [
    CustomerTargetUrlsComponent,
    CommentsComponent,
    FilesLegacyComponent,
    FilesComponent
  ]
})
export class ActionComponentsModule { }
